import { otsBaseApi } from '../../ots-api';
import {
  ApplyGeofenceOverlapRequest,
  BulkApplyGeofenceOverlapRequest,
  GeofenceOverlapApplyItemResult,
  GeofenceOverlapBulkApplyResponse,
  GeofenceOverlapPageRequest,
  GeofenceOverlapScanPage,
  GeofenceOverlapScanRequest,
} from '../../../model/geofence-overlap';
import { removeUndefined } from '../../../util/util';

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: [
    'GeofenceOverlapSuggestions',
    'GeofenceSiteGroups',
    'GeofenceSiteGroupSites',
    'Sites',
  ],
});

const changedEntityTags = [
  { type: 'GeofenceSiteGroups' as const },
  { type: 'GeofenceSiteGroupSites' as const },
  { type: 'Sites' as const },
];

export const geofenceOverlapApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    createGeofenceOverlapScan: builder.mutation<
      GeofenceOverlapScanPage,
      GeofenceOverlapScanRequest
    >({
      query: ({ regionId, minOverlapMeters, page, size, q, kind }) => ({
        url: '/geofence-site-groups/overlap-suggestions/scans',
        method: 'POST',
        params: removeUndefined({
          regionId,
          minOverlapMeters,
          page,
          size,
          q,
          kind,
        }),
      }),
    }),
    getGeofenceOverlapScanPage: builder.query<
      GeofenceOverlapScanPage,
      GeofenceOverlapPageRequest
    >({
      // the threshold belongs to the scan token, so paging never resends it
      query: ({ scanToken, regionId, page, size, q, kind }) => ({
        url: `/geofence-site-groups/overlap-suggestions/scans/${scanToken}`,
        method: 'GET',
        params: removeUndefined({ regionId, page, size, q, kind }),
      }),
      providesTags: (result, _error, { scanToken }) => [
        {
          type: 'GeofenceOverlapSuggestions',
          id: result?.scanToken ?? scanToken,
        },
      ],
    }),
    applyGeofenceOverlapSuggestion: builder.mutation<
      GeofenceOverlapApplyItemResult,
      ApplyGeofenceOverlapRequest
    >({
      query: ({ regionId, ...body }) => ({
        url: '/geofence-site-groups/overlap-suggestions/apply',
        method: 'POST',
        params: removeUndefined({ regionId }),
        body,
      }),
      invalidatesTags: changedEntityTags,
    }),
    bulkApplyGeofenceOverlapSuggestions: builder.mutation<
      GeofenceOverlapBulkApplyResponse,
      BulkApplyGeofenceOverlapRequest
    >({
      query: ({ regionId, ...body }) => ({
        url: '/geofence-site-groups/overlap-suggestions/bulk-apply',
        method: 'POST',
        params: removeUndefined({ regionId }),
        body,
      }),
      invalidatesTags: changedEntityTags,
    }),
  }),
});

export const {
  useCreateGeofenceOverlapScanMutation,
  useGetGeofenceOverlapScanPageQuery,
  useApplyGeofenceOverlapSuggestionMutation,
  useBulkApplyGeofenceOverlapSuggestionsMutation,
} = geofenceOverlapApi;
